import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {LoginComponent} from "./login";
import {RegistrationComponent} from "./registration/registration.component";
import {RestorePasswordComponent} from "./restore-password/restore-password.component";
import {WelcomeMainComponent} from "./welcome-part.component";
import {ViewSettingResolver} from "../main-page/view-setting-service/view-setting.resolver";
/**
 * Created by Rumyantsev Daniil on 07.09.2017.
 */

const tmpNameRoutes: Routes = [
  {
    path: '',
    component: WelcomeMainComponent,
    resolve: {
      viewSetting: ViewSettingResolver
    },
    children: [
      {
        path: 'registration',
        component: RegistrationComponent
      },
      {
        path: 'restore-password',
        component: RestorePasswordComponent
      },
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'prefix'
      },
      {
        path: '**',
        redirectTo: 'error',
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(tmpNameRoutes,
  )],
  exports: [RouterModule]
})
export class TmpNameRoutingModule {
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/tmpName/tmpName-routing.module.ts